import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';

@Pipe({
    name: 'translate',
    pure: true,
    standalone: false
})
export class TranslatePipe implements PipeTransform {
  constructor(private localization: LocalizationService) {}

  transform(key: string): string {
    return this.localization.translate(key);
  }
}